import axios from "axios";
import { getApiBase } from "../apiBase";

function baseUrl(apiUrl) {
  return apiUrl || getApiBase();
}

export async function fetchProjectPermitCoverage(projectId, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/projects/${projectId}/permit-coverage`, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function saveProjectPermitCoverage(
  projectId,
  body,
  { apiUrl, getAuthHeaders } = {}
) {
  const { data } = await axios.put(
    `${baseUrl(apiUrl)}/projects/${projectId}/permit-coverage`,
    body,
    { headers: getAuthHeaders?.() }
  );
  return data;
}
